<template>
  <div id="root">
    <div class="sc-hEsumM gHkFqx">
      <div class="sc-cIShpX hYCoxO">
        <!-- 左侧组件 -->
        <LeftNavigation :navArr="navArr" :index="currentIndex" />
      </div>
      <!-- 主内容区域 -->
      <router-view />
    </div>
    <nav class="sc-bwCtUz kItZuH" style="bottom: 0px;">
      <a class="nav-tab" @click="handleTo('/')">
        <i class="icon-home"></i>
        <span>Home</span>
      </a>
      <a class="nav-tab" @click="handleTo('/order')">
        <i class="icon-dollar-sign"></i>
        <span>Order</span>
      </a>
      <a class="nav-tab" @click="handleTo('/settings/account')">
        <i class="icon-user"> </i>
        <span>Settings</span>
      </a>
    </nav>
    <Login :dataVal="loginObj" @loginCall="loginCall"></Login>
  </div>
</template>

<script>
import LeftNavigation from '@/components/LeftNavigation.vue'
import Login from '@/components/Login.vue'
export default {
  name: "MainLayout",
  components: {
    LeftNavigation,
    Login
  },
  data() {
    return {
      navArr: [],
      currentIndex: 0,

      timer: null,

      loginObj: {
        flag: false
      }
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      if (window.location.hash == '#/signup') {
        this.loginObj.flag = false
      } else {
        if (!window.localStorage.getItem('token')) {
          this.loginObj.flag = true
        } else {
          this.loginObj.flag = false
        }
      }
    }, 1000)
  },
  methods: {
    loginCall(obj) {
      this.loginObj.flag = false
      // 刷新页面
      window.location.reload()
      this.$router.push('/')
    },
    handleTo(path) {
      this.$router.push(path)
    }
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.path != '/signup') {
          if (!window.localStorage.getItem('token')) {
            this.loginObj.flag = true
          } else {
            this.loginObj.flag = false
          }
        } else {
          this.loginObj.flag = false
        }
      },
      deep: true,
      immediate: true
    },
  },
  // 离开销毁定时器
  beforeDestroy() {
    clearInterval(this.timer)
  }
};
</script>

<style lang="scss" scoped>
.gHkFqx {
  width: 100%;
  display: flex;

  .hYCoxO {
    bottom: 0px;
    position: absolute;
    top: 0px;
    z-index: 10;
  }
}

.kItZuH {
  background: rgb(0, 0, 0);
  height: 50px;
  left: 0px;
  padding-bottom: 0px;
  position: fixed;
  transform: translate3d(0px, 0px, 0px);
  transition: 225ms cubic-bezier(0, 0, 0.2, 1);
  width: 100vw;
  z-index: 100;
  display: none;

  .nav-tab {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    height: 100%;
    -webkit-box-pack: center;
    justify-content: center;
    text-decoration: none;

    i {
      color: rgb(255, 255, 255);
      font-size: 20px;
      padding: 0px;
    }

    span {
      color: white;
      font-size: 12px;
      padding-top: 3px;
    }
  }
}

@media screen and (max-width: 769px) {
  .hYCoxO {
    display: none;
  }

  .kItZuH {
    display: flex;
  }
}
</style>
